module.exports = "\n<div class=\"g-historical-data\" _v-10a62da8=\"\">\n    <loader class=\"loader\" v-if=\"loading\" _v-10a62da8=\"\"></loader>\n    <div ref=\"plotArea\" class=\"plot-area\" _v-10a62da8=\"\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-10a62da8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/HistoricalData.vue
// module id = 506
// module chunks = 0